// extracted by mini-css-extract-plugin
export default {"container":"style_container__4ihAR","top":"style_top__E4hVm","backButton":"style_backButton__EOkzd","tabsButton":"style_tabsButton__RDY0O","button":"style_button__MAQL-"};